var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5575 1.30167L10.9689 1.11426L10.7728 2.75297L9.26298 2.82154L9.16035 4.36883L7.66193 4.42597L6.77474 5.31503C5.24895 4.80765 3.49965 5.15733 2.28632 6.37551C0.571228 8.09422 0.571228 10.878 2.28632 12.5967C4.0014 14.3154 6.7793 14.3154 8.49439 12.5967C9.6986 11.3899 10.0544 9.65751 9.56632 8.13535L13.7719 3.92087L13.5575 1.30167Z",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64941 7.00859L12.2278 3.42262",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72425 11.4174C5.40444 11.4174 5.95583 10.8648 5.95583 10.1832C5.95583 9.50157 5.40444 8.94901 4.72425 8.94901C4.04407 8.94901 3.49268 9.50157 3.49268 10.1832C3.49268 10.8648 4.04407 11.4174 4.72425 11.4174Z",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyIcon);
export default __webpack_public_path__ + "static/media/KeyIcon.128aa60e4b4fe40ba6309dbcb5cd132a.svg";
export { ForwardRef as ReactComponent };